import { useEffect, useState } from 'react'
import { HeaderImport } from './Import'
const { RoutesMap, logo, useNavigate, useDispatch, Dropdown, KeyRound, Languages, ListCollapse, Power, UserPen, img_nf, dayjs, ChangePassword, toast, toggleChangePasswordModal, SessionManager, signOut, useTranslation } = HeaderImport

export default function Header(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props
    const [date, setDate] = useState(new Date().toDateString())
    const [time, setTime] = useState(dayjs().format("HH:mm:ss"))
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    let cookieUser = SessionManager.getCookie("user");
    let user_details = cookieUser ? JSON.parse(cookieUser) : null;
    // console.log(user_details)

    const lang_option = {
        items: [
            { key: 'en', label: 'English' },
        ],
        selectable: true,
        defaultSelectedKeys: [i18n?.language],
        onClick: ({ key }) => {
            i18n.changeLanguage(key)
        },
    };

    const settings_option = [
        {
            key: '1',
            label: 'Profile',
            icon: <UserPen size={16} />,
            onClick: () => navigate('/profile')
        },
        {
            key: '2',
            label: 'Change Password',
            icon: <KeyRound size={16} />,
            onClick: () => changePasswordModal()
        },
        {
            type: 'divider',
        },
        {
            key: '3',
            label: 'Log Out',
            icon: <Power size={16} />,
            onClick: () => logout()
        },
    ];

    const changePasswordModal = () => dispatch(toggleChangePasswordModal())

    const logout = () => {
        dispatch(signOut({ navigate })).then((res) => {
            const response = res.payload
            if (response?.status === 200) {
                // Clear all session data
                SessionManager.removeCookie("user_token");
                SessionManager.removeCookie("user");
                SessionManager.clearSession();
                // Navigate to login
                navigate(RoutesMap.LOGIN.path)
            } else if (response?.status === 401) {
                // Token expired, clear and redirect
                SessionManager.removeCookie("user_token");
                SessionManager.removeCookie("user");
                SessionManager.clearSession();
                navigate(RoutesMap.LOGIN.path)
            } else {
                // Show error toast for other statuses
                toast.error(response?.data?.message || "Something went wrong. Please try again.", { position: "bottom-right", closeOnClick: true });
            }
        })
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(dayjs().format("HH:mm:ss"));
        }, 1000);

        return () => clearInterval(interval);
    }, [])

    // Mobile menu options combining all actions
    const mobileMenuOptions = [
        {
            key: 'time',
            label: (
                <span className='text-dark fw-medium' style={{ fontSize: '13px' }}>
                    🕒 {time}
                </span>
            ),
            disabled: true,
        },
        {
            type: 'divider',
        },
        {
            key: 'lang',
            label: 'English',
            icon: <Languages size={16} />,
            onClick: () => lang_option.onClick({ key: 'en' })
        },
        {
            key: 'company',
            label: 'Techlene Software Solutions',
            icon: <span style={{ fontSize: '12px' }}>🌐</span>,
            onClick: () => window.open('https://www.techlene.com/', '_blank')
        },
        {
            type: 'divider',
        },
        ...settings_option
    ];

    return (
        <>
            <nav className={`navbar fixed-top ${isMobileOrTablet ? 'navbar_mobile_view' : collapsed ? "navbar_body_collapsed" : "navbar_body_notcollapsed"}`} >
                <div className="container-fluid px-2 px-md-3">
                    <span className="navbar-brand d-flex align-items-center flex-grow-1">
                        <ListCollapse
                            onClick={() => isMobileOrTablet ? setDrawerOpen(!drawerOpen) : setCollapsed(!collapsed)}
                            style={{ cursor: 'pointer', flexShrink: 0 }}
                            size={isMobileOrTablet ? 20 : 24}
                        />
                        <span className='d-flex flex-column ms-2 ms-md-3 flex-grow-1 min-w-0'>
                            <span
                                style={{
                                    fontSize: isMobileOrTablet ? '11px' : '12px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}
                                className="fw-bold"
                            >
                                Welcome, {user_details ? `${user_details?.userDetails?.user_name || ""}` : "Guest"}!
                            </span>
                            <span
                                style={{ fontSize: isMobileOrTablet ? '9px' : '10px' }}
                                className='text-secondary'
                            >
                                {date}
                            </span>
                        </span>
                    </span>

                    {/* Desktop View (≥992px) - Full Menu */}
                    <div className='d-none d-lg-flex align-items-center flex-shrink-0'>
                        <span className='text-dark fw-medium' style={{ fontSize: '13px' }}>🕒 {time}</span>
                        <span className='ms-2 me-2'>|</span>
                        <Dropdown
                            menu={lang_option}
                            placement="bottom"
                        >
                            <Languages size={20} style={{ cursor: 'pointer' }} />
                        </Dropdown>
                        <span className='ms-2 me-2'>|</span>
                        {/* <span 
                            className='fw-medium orange' 
                            style={{ cursor: 'pointer', fontSize: '13px' }} 
                            onClick={() => window.open('https://www.techlene.com/', '_blank')}
                        >
                            Techlene Software Solutions Pvt. Ltd.
                        </span> */}
                        <img src={logo} alt="logo" className='img-fluid' style={{ height: '30px' }} />
                        <span className='ms-2 me-2'>|</span>
                        <Dropdown
                            menu={{ items: settings_option }}
                            placement="bottom"
                        >
                            <img
                                src={user_details?.userDetails?.user_profile && process.env.REACT_APP_BASE_URL + user_details?.userDetails?.user_profile || img_nf}
                                alt="admin"
                                className='img-fluid header_profile_img'
                                style={{ cursor: 'pointer' }}
                                onError={(e) => { e.target.onerror = null; e.target.src = img_nf }}
                            />
                        </Dropdown>
                    </div>

                    {/* Tablet View (576px-991px) - Simplified Menu */}
                    <div className='d-none d-sm-flex d-lg-none align-items-center flex-shrink-0'>
                        <span className='text-dark fw-medium' style={{ fontSize: '12px' }}>🕒 {time}</span>
                        <span className='ms-2 me-2'>|</span>
                        <Dropdown
                            menu={lang_option}
                            placement="bottom"
                        >
                            <Languages size={18} style={{ cursor: 'pointer' }} />
                        </Dropdown>
                        <span className='ms-2 me-2'>|</span>
                        <Dropdown
                            menu={{ items: settings_option }}
                            placement="bottom"
                        >
                            <img
                                src={user_details?.userDetails?.user_profile && process.env.REACT_APP_BASE_URL + user_details?.userDetails?.user_profile || img_nf}
                                alt="admin"
                                className='img-fluid header_profile_img'
                                style={{ cursor: 'pointer', height: '32px', width: '32px' }}
                                onError={(e) => { e.target.onerror = null; e.target.src = img_nf }}
                            />
                        </Dropdown>
                    </div>

                    {/* Mobile View - Menu Button */}
                    <div className='d-flex d-sm-none align-items-center flex-shrink-0'>
                        <Dropdown
                            menu={{ items: mobileMenuOptions }}
                            placement="bottomRight"
                            trigger={['click']}
                        >
                            <div
                                style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                            >
                                <img
                                    src={user_details?.userDetails?.user_profile && process.env.REACT_APP_BASE_URL + user_details?.userDetails?.user_profile || img_nf}
                                    alt="admin"
                                    className='img-fluid header_profile_img'
                                    style={{ cursor: 'pointer', height: '30px', width: '30px' }}
                                    onError={(e) => { e.target.onerror = null; e.target.src = img_nf }}
                                />
                                <span style={{ fontSize: '11px', color: '#666' }}>🕒 {time}</span>
                            </div>
                        </Dropdown>
                    </div>
                </div>
            </nav>

            <ChangePassword />
        </>
    )
}